import EventEmitter from 'events'
import {
  fetchDocuments,
  uploadDocument
} from '../../api/documents'
import {
  DOCUMENTS_STATE_UPDATE
} from '../../actions'

class DocumentsManager {
  constructor () {
    this.emitter = new EventEmitter()
    this.emitter.setMaxListeners(5)
    this.__loading = false
  }

  // subscribe/unsubscribe/dispatch actions
  subscribeToActions (actionHandler) {
    this.emitter.addListener('action', actionHandler)
  }

  unsubscribeFromActions (actionHandler) {
    this.emitter.removeListener('action', actionHandler)
  }

  takeAction (action) {
    this.emitter.emit('action', action)
  }

  fetchDocuments () {
    if (this.__loading) {
      return
    }
    this.__loading = true
    this.takeAction({
      type: DOCUMENTS_STATE_UPDATE,
      payload: {
        loading: true
      }
    })

    return fetchDocuments()
      .then(data => {
        const { documentTypes, documents } = data

        this.takeAction({
          type: DOCUMENTS_STATE_UPDATE,
          payload: {
            documentTypes,
            documents,
            loading: false,
            error: null
          }
        })

        this.__loading = false
        return data
      })
      .catch(err => {
        this.takeAction({
          type: DOCUMENTS_STATE_UPDATE,
          payload: {
            loading: false,
            error: err
          }
        })
        this.__loading = false
        throw err
      })
  }

  uploadDocument (formData) {
    if (this.__loading) {
      return
    }
    this.__loading = true

    return uploadDocument(formData)
      .then((res) => {
        this.__loading = false

        if (res) {
          this.fetchDocuments()
        }

        return res
      })
      .catch(err => {
        this.takeAction({
          type: DOCUMENTS_STATE_UPDATE,
          payload: {
            loading: false,
            error: err
          }
        })
        this.__loading = false
        throw err
      })
  }
}

const $documents = new DocumentsManager()

// In dev mode allow access from console
if (process.env.NODE_ENV === 'development') {
  window.$documents = $documents
}

export default $documents
